export const createRedirectUrl = (path: string) => {
	const getUrl = window.location;
	return `${getUrl.protocol}//${getUrl.host}${path}`;
};
